import { render, staticRenderFns } from "./SocialProof.vue?vue&type=template&id=0004e25e&scoped=true"
import script from "./SocialProof.js?vue&type=script&lang=js&external"
export * from "./SocialProof.js?vue&type=script&lang=js&external"
import style0 from "./SocialProof.scss?vue&type=style&index=0&id=0004e25e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0004e25e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTitle: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Title/Title.vue').default,HotButton: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Button/Button.vue').default})
